import _ from 'lodash';
import Enums from '../gridEnums';
// import reporter from '../reporter';
// import {generateError} from './errors';

const GALLERY_SCHEMA = {
    galleryImageOnClickAction: {
        schemaType: ['string'],
        enum: ['none', 'expand', 'link'],
        warnIfNil: true,
        acceptNil: true,
        validations: {
            type: true
        }
    },
    showNavigation: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    arrowMode: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    onChange: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    onItemClicked: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    items: {
        schemaType: ['array'],
        acceptNil: true,
        warnIfNil: true,
        validations: {
            type: true
        }
    },
    options: {
        schemaType: ['object'],
        validations: {
            type: true
        }
    },
    compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'playableMixin']
};
const compDataSchemas = {
    Image: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            mandatory: true,
            validations: {
                type: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        title: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        alt: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        tooltip: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        width: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        height: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        clickAction: {
            schemaType: ['string'],
            enum: ['none', 'link', 'expand', 'magnified'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        },
        fitMode: {
            schemaType: ['string'],
            enum: ['fit', 'fill', 'fixedWidth'],
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'linkableMixin']
    },
    Gallery: GALLERY_SCHEMA,
    ProGallery: GALLERY_SCHEMA,
    GoogleMap: {
        onMarkerClicked: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onMapClicked: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        getVisibleMarkers: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        markers: {
            schemaType: ['array'],
            acceptNil: false,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        zoom: {
            schemaType: ['number'],
            maxVal: 18,
            minVal: 0,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        title: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        linkTitle: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        link: {
            schemaType: ['url'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        icon: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: false,
            validations: {
                type: true
            }
        },
        address: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        latitude: {
            schemaType: ['number'],
            maxVal: 90,
            minVal: -90,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        longitude: {
            schemaType: ['number'],
            maxVal: 180,
            minVal: -180,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    Box: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Button: {
        compExtensions: ['linkableMixin', 'clickableMixin', 'viewportMixin', 'element', 'labelMixin']
    },
    Lightbox: {
        name: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    modal: {
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            },
            width: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            height: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            theme: {
                schemaType: ['string'],
                enum: ['DEFAULT', 'BARE'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },

    popup: {
        url: {
            schemaType: ['url'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            },
            width: {
                schemaType: ['number', 'string'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            height: {
                schemaType: ['number', 'string'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            position: {
                schemaType: ['object'],
                mandatory: true,
                validations: {
                    type: true
                },
                origin: {
                    schemaType: ['string'],
                    enum: ['FIXED', 'RELATIVE', 'ABSOLUTE'],
                    mandatory: true,
                    validations: {
                        type: true
                    }
                },
                placement: {
                    schemaType: ['string'],
                    enum: ['TOP_LEFT', 'TOP_CENTER', 'TOP_RIGHT', 'CENTER_LEFT', 'CENTER',
                        'CENTER_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_CENTER', 'BOTTOM_RIGHT', 'CENTER'],
                    acceptNil: true,
                    validations: {
                        type: true
                    }
                }

            },
            theme: {
                schemaType: ['string'],
                enum: ['DEFAULT', 'BARE'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },

    sectionUrl: {
        sectionId: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },

    sectionIdentifier: {
        sectionIdentifier: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        sectionId: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        appDefinitionId: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },

    trackEvent: {
        eventName: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        data: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    Slideshow: {
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        showNavigationButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        showSlideButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        compExtensions: ['playableMixin', 'clickableMixin', 'viewportMixin', 'element'],
        slideInfo: {
            schemaType: ['object', 'integer'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    MultiStateBox: {
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        stateInfo: {
            schemaType: ['object', 'string'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    Checkbox: {
        label: {
            schemaType: ['string'],
            acceptNil: true,
            maxLength: 400,
            minLength: 0,
            validations: {
                type: true,
                length: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin', 'checkedMixin']
    },
    Column: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    ColumnStrip: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    DatePicker: {
        value: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        maxDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        minDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        disabledDates: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDate'
        },
        disableDate: {
            schemaType: ['date'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        disabledDaysOfWeek: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDayOfWeek'

        },
        disableDayOfWeek: {
            schemaType: ['number'],
            enum: [0, 1, 2, 3, 4, 5, 6],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin', 'readOnlyMixin']
    },
    Video: {
        videoUrl: {
            schemaType: ['url'],
            validationExpressions: 'validateVideoUrlFormats',
            validations: {
                type: true,
                regex: true
            }
        },
        compExtensions: ['element', 'viewportMixin']
    },
    Dropdown: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'selectOption'
        },
        selectOption: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        placeholder: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        selectedIndex: {
            acceptNil: true,
            schemaType: ['integer'],
            validations: {
                type: true
            }
        }
    },
    RadioButtonGroup: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'RadioButton'
        },
        RadioButton: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        selectedIndex: {
            schemaType: ['integer'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    CheckboxGroup: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'Checkbox'
        },
        CheckboxInput: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            checked: {
                schemaType: ['boolean'],
                acceptNil: true,
                validations: {
                    type: true
                }
            },
            value: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        value: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        selectedIndices: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    UploadButton: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin'],
        filesSizeLimit: {
            schemaType: ['number'],
            maxVal: 15,
            minVal: 1,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        buttonLabel: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }

        },
        filesType: {
            schemaType: ['string'],
            enum: [
                'Image',
                'Document',
                'Video',
                'Audio'
            ],
            validations: {
                type: true
            }
        }
    },
    Footer: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Header: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Page: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    HoverBox: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'backgroundMixin']
    },
    Shape: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    Slide: {
        compExtensions: ['viewportMixin', 'element', 'backgroundMixin']
    },
    State: {
        compExtensions: ['viewportMixin', 'element', 'backgroundMixin']
    },
    Text: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        text: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        },
        html: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    TextBox: {
        compExtensions: ['clickableMixin', 'requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        wrap: {
            schemaType: ['string'],
            enum: ['hard', 'soft'],
            validations: {
                type: true
            }
        }
    },
    TextInput: {
        compExtensions: ['clickableMixin', 'requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        min: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        max: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        inputType: {
            schemaType: ['string'],
            enum: ['text', 'email', 'number', 'password', 'tel', 'url'],
            validations: {
                type: true
            }
        }
    },
    HtmlComponent: {
        compExtensions: ['viewportMixin', 'element'],
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        message: {
            schemaType: ['object', 'string', 'number', 'boolean', 'array'],
            validations: {
                type: true
            }
        },
        onMessage: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        scrolling: {
            schemaType: ['string'],
            enum: ['no', 'yes', 'auto'],
            validations: {
                type: true
            }
        }
    },
    Repeater: {
        data: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        },
        callback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        _id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        ids: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    Container: {
      compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    Table: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        onRowSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        dataFetcherCallback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onCellSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        rowIndex: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        rows: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        row: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        columns: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        column: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            id: {
                schemaType: ['string'],
                mandatory: true,
                validations: {
                    type: true
                }
            }
        },
        sorting: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        filter: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        pagination: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            type: {
                schemaType: ['string'],
                mandatory: true,
                enum: _.map(Enums.PaginationType),
                validations: {
                    type: true
                }
            },
            rowsPerPage: {
                schemaType: ['number'],
                validations: {
                    type: true
                }
            }
        }
    },
    Window: {
        x: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        y: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        payload: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['parent'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        appDefinitionId: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        text: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    Document: {
        url: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    Location: {
        url: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        linkData: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        callback: {
            schemaType: ['function'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    Site: {
        appDefinitionId: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        eventData: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        itemsToLoad: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        pages: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        lightboxes: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    VectorImage: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    VerticalMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    AccountNavBar: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    MobileMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    BasicMenuItem: {
        schemaType: ['object'],
        validations: {
            type: true
        },
        visibleOnDesktop: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        visibleOnMobile: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        icon: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        displayCount: {
            schemaType: ['number'],
            acceptNil: true,
            warnIfNil: false,
            validations: {
                type: true
            }
        },
        items: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'BasicMenuItem'
        }
    },
    QuickActionBar: {
        showLabels: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        alignment: {
            schemaType: ['string'],
            enum: ['left', 'right'],
            validations: {
                type: true
            }
        },
        colorScheme: {
            schemaType: ['string'],
            enum: ['brand', 'grey', 'black'],
            validations: {
                type: true
            }
        },
        invertColorScheme: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        onItemClicked: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    }
};

const compExtensions = {
    viewportMixin: {
        onViewportLeave: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onViewportEnter: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    linkableMixin: {
        link: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['_blank', '_self'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    clickableMixin: {
        onClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onDblClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    playableMixin: {
        onPause: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onPlay: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    readOnlyMixin: {
        readonly: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    requiredMixin: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    textInputMixin: {
        placeholder: {
            schemaType: ['string'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        maxlength: {
            schemaType: ['integer'],
            minVal: 0,
            acceptNil: true,
            validations: {
                type: true,
                minimum: true
            }
        },
        onKeyPress: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onInput: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    backgroundMixin: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    focusMixin: {
        onFocus: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onBlur: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    element: {
        onMouseIn: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onMouseOut: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    formElement: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        value: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    checkedMixin: {
        checked: {
            schemaType: ['boolean'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    labelMixin: {
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    }
};

function getSchemaOfComp(compType) {
    const compDataSchema = _.clone(_.get(compDataSchemas, compType));
    if (!compDataSchema) {
        return;
    }
    const res = {};
    if (compDataSchema.compExtensions) {
        compDataSchema.compExtensions.forEach((mixinName) => {
            const mixinSchema = compExtensions[mixinName];
            _.assign(res, mixinSchema);
        });
    }
    _.assign(res, compDataSchema);
    return res;

}

function extendCompSchema(type, schema) {
    if(compDataSchemas[type]){
        // reporter.reportSdkError(generateError.error_compSchemaType_already_exists({type}));
        return false;
    }

    _.set(compDataSchemas, type, schema);
    return true;
}

export {
    getSchemaOfComp,
    extendCompSchema
};
